// extracted by mini-css-extract-plugin
export var actions = "_f1-d";
export var benefitCard = "_f1-a";
export var benefitIcon = "_f1-b";
export var benefitLabel = "_f1-c";
export var benefits = "_f1-9";
export var bodyText = "_f1-8";
export var closeButton = "_f1-2";
export var content = "_f1-3";
export var eyebrow = "_f1-4";
export var heading = "_f1-5";
export var image = "_f1-f";
export var imagePanel = "_f1-e";
export var modal = "_f1-0";
export var shell = "_f1-1";
export var title = "_f1-6";
export var titleOffer = "_f1-7";